import { Drawer, Box, IconButton, List, ListItem, ListItemButton, ListItemText, Divider } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'
import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { navigationItems, primaryCTA } from '@/data/navigation'
import { Button } from '@/components/common'

/**
 * Mobile Navigation Drawer Component
 * Hamburger menu with drawer for mobile screens
 */
export const MobileNav = () => {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen)
  }

  const handleNavClick = (href: string) => {
    // Close drawer
    setDrawerOpen(false)
    
    // Navigate to route
    navigate(href)
  }

  return (
    <>
      {/* Hamburger Icon Button - Visible on mobile only */}
      <IconButton
        edge="end"
        aria-label="menu"
        onClick={handleDrawerToggle}
        sx={{
          display: { xs: 'block', md: 'none' },
          color: '#ffffff',
        }}
      >
        <MenuIcon />
      </IconButton>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            width: 280,
            boxSizing: 'border-box',
          },
        }}
      >
        <Box role="presentation">
          {/* Close Button */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              p: 1,
            }}
          >
            <IconButton onClick={handleDrawerToggle} aria-label="close menu">
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider />

          {/* Navigation Items */}
          <List>
            {navigationItems.map((item) => (
              <ListItem key={item.href} disablePadding>
                <ListItemButton 
                  onClick={() => handleNavClick(item.href)}
                  selected={location.pathname === item.href}
                >
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      fontWeight: location.pathname === item.href ? 600 : 500,
                      fontSize: '1rem',
                      color: location.pathname === item.href ? 'primary.main' : 'text.primary',
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>

          <Divider />

          {/* CTA Button */}
          <Box sx={{ p: 2 }}>
            <Button
              variant="primary"
              fullWidth
              onClick={() => handleNavClick(primaryCTA.href)}
            >
              {primaryCTA.label}
            </Button>
          </Box>
        </Box>
      </Drawer>
    </>
  )
}
